import type { Props } from 'react'
import { Component } from 'react'

import { ListItemIcon } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { theme } from '@procurify/ui-theme'

import { type IconElement } from '../../../elements/Icon'

const styles = {
  root: {
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: theme.space.small,
    marginRight: 0,
    color: theme.colors.darkGrey,
    minWidth: 0,
  },
}

interface ListItemIconStyledProps extends Props<any> {
  pIcon?: IconElement
  className?: string
}

class ListItemIconStyledComponent extends Component<
  { classes: any } & ListItemIconStyledProps
> {
  render() {
    const { classes, children, ...otherProps } = this.props
    return children ? (
      <ListItemIcon
        classes={{ root: classes.root }}
        className={this.props.className}
      >
        <>{children}</>
      </ListItemIcon>
    ) : null
  }
}

export const ListItemIconStyled = withStyles(styles)(
  ListItemIconStyledComponent
)
